// import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/HomePage";
import { Routes, Route, useLocation } from "react-router-dom";
import FarmListPage from "./pages/farm-list/FarmListPage.jsx";
import FarmListing from "./pages/dashboard/admin/listings/farm/FarmListing.jsx";
import EventListing from "./pages/dashboard/admin/listings/event/EventListing.jsx";

import Footer from "./layouts/Footer";
import Header from "./layouts/Header";
import BlogHeader from "./layouts/BlogHeader";
import ListHeader from "./layouts/ListHeader";
import ExploreHeader from "./layouts/ExploreHeader";
import ProfileHeader from "./layouts/ProfileHeader";
// import WideHeader from "./layouts/WideHeader";
import "./assets/scripts/index.js";
import ScrollToTop from "./components/ScrollToTop";
import { MapViewProvider } from "./hooks/MapViewContext.js";
import { useEffect } from "react";

// 한국 투자용 임시데이터 - 나중에 제거 예정
import KoreaHeader from "./layouts/KoreaHeader.jsx";
import GlobalFarmPage from "./pages/global/GlobalFarmPage.jsx";
import YongggumVillage from "./pages/global/korea/YongggumVillage.jsx";
import GapaVillage from "./pages/global/korea/GapaVillage.jsx";
import OnuiVillage from "./pages/global/korea/OnuiVillage.jsx";
// 여기까지 한국 투자용 임시데이터 - 제거 예정

import FarmDetailPage from "./pages/farm-detail/FarmDetailPage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";
import SearchList from "./pages/search-list/SearchList.jsx";
import FarmStayPage from "./pages/stay/FarmStayPage.jsx";
import FarmExperiencePage from "./pages/experience/FarmExperiencePage.jsx";
import ExperienceDetailPage from "./pages/experience/experience-detail/ExperienceDetailPage.jsx";
import FarmStorePage from "./pages/store/FarmStorePage.jsx";
import StoreListPage from "./pages/store/store-list/StoreListPage.jsx";
import EmailVerified from "./components/common/EmailVerified.jsx";

import WPPostsPage from "./pages/blog/blog-categories/WPPostsPage.jsx";

import FamilyBlogPage from "./pages/blog/blog-categories/FamilyBlogPage";
import ChristmasMarketsBlogPage from "./pages/blog/blog-categories/ChristmasMarketsBlogPage";
import VancouverChristmasMarketsBlogPage from "./pages/blog/blog-categories/VancouverChristmasMarketBlogPage";

import LavenderFarmOntario from "./pages/blog/blog-categories/LavenderFarmOntario";
import BloomingAdventures from "./pages/blog/blog-categories/BloomingAdventures.jsx";
import April from "./pages/blog/blog-categories/April.jsx";
import CelebrateEaster from "./pages/blog/blog-categories/CelebrateEaster.jsx";
import March from "./pages/blog/blog-categories/March.jsx";
import MapleSyrup from "./pages/blog/blog-categories/MapleSyrup.jsx";
import MapleSyrupFarm from "./pages/blog/blog-categories/25MapleSyrup.jsx";
import February from "./pages/blog/blog-categories/February.jsx";
import Evergreen from "./pages/blog/blog-categories/Evergreen.jsx";
import Christmas from "./pages/blog/blog-categories/Christmas.jsx";
import MapleSyrupQC from "./pages/blog/blog-categories/MapleSyrupQC.jsx";
import MapleSyrupON from "./pages/blog/blog-categories/MapleSyrupON.jsx";

import BlogPage from "./pages/blog/BlogPage.jsx";
import ProfilePage from "./pages/dashboard/common/ProfilePage.jsx";
import PasswordSecurityPage from "./pages/dashboard/common/PasswordSecurityPage";
import SettingsPage from "./pages/dashboard/common/SettingsPage";
import NotificationPage from "./pages/dashboard/common/NotificationPage";
import FarmSeoPage from "./pages/dashboard/admin/seo/FarmSeoPage.jsx";

import BookmarksPage from "./pages/dashboard/common/Bookmarks.jsx";
import FavoritesPage from "./pages/dashboard/common/Favorites.jsx";

// Auth0 imports
import RoleSelectionPage from "./pages/auth/RoleSelectionPage.jsx";
import AuthCallbackPage from "./pages/auth/AuthCallbackPage.jsx";
import { ProtectedRoute } from "./components/auth/ProtectedRoute.jsx";

function App() {
  const loc = useLocation();
  const path = loc.pathname;

  // Calculate and set scrollbar width globally to prevent layout shift
  useEffect(() => {
    const calculateScrollbarWidth = () => {
      // Create a temporary element to measure scrollbar width
      const outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.overflow = "scroll";
      outer.style.msOverflowStyle = "scrollbar";
      outer.style.width = "100px";
      outer.style.height = "100px";
      document.body.appendChild(outer);

      const inner = document.createElement("div");
      inner.style.width = "100%";
      inner.style.height = "100%";
      outer.appendChild(inner);

      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
      document.body.removeChild(outer);

      // Set the calculated scrollbar width as a CSS custom property
      document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${scrollbarWidth}px`
      );

      return scrollbarWidth;
    };

    // Calculate scrollbar width on app mount
    calculateScrollbarWidth();

    // Recalculate on window resize
    const handleResize = () => {
      calculateScrollbarWidth();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isFarmPage = path.startsWith("/farm");
  const isCategoryPage = path.startsWith("/category");
  const isListingPage = path.startsWith("/listing");
  const isSearchPage = path.startsWith("/search");
  const isGlobalFarmPage = path.startsWith("/global");
  const isExperienceDetailPage = path.match(/^\/experience\/[^\/]+$/);
  const isExplorePage =
    (path.startsWith("/stay") ||
      path.startsWith("/experience") ||
      path.startsWith("/store")) &&
    !isExperienceDetailPage;
  const isBlogPage = path.startsWith("/list-blog"); // Check list-blog first (more specific)
  const isMainBlogPage = path.startsWith("/blog") && !isBlogPage; // Then check /blog (but exclude list-blog)
  const isProfilePage =
    path.startsWith("/dashboard/common") ||
    path.startsWith("/dashboard/admin") ||
    path.startsWith("/dashboard/farmer");

  // Check if current path matches any of our defined routes
  // Include all valid static routes - both existing and planned routes from navigation
  const validRoutes = [
    "/",
    "/farm/:farmId/:farmName",
    "/category/:categoryId",
    "/search",
    "/stay",
    "/experience",
    "/store",
    "/list-blog",
    "/blog",
    "/auth/signup",
    "/auth/callback",
    "/dashboard/common/profile",
    "/dashboard/common/password-security",
    "/dashboard/common/settings",
    "/dashboard/common/notifications",
    "/dashboard/common/bookmarks",
    "/dashboard/common/favorites",
    "/dashboard/admin/seo/farms",
    "/dashboard/admin/farm/listing",
    "/dashboard/admin/event/listing",
    // 나중에 삭제 시작
    "/global",
    "/global/korea/yongggum-village",
    "/global/korea/gapa-village",
    "/global/korea/onui-village"
    // 나중에 삭제 끝
  ];
  // Handle dynamic routes with parameters
  const isDynamicRoute =
    path.match(/^\/farm\/[^\/]+\/[^\/]+$/) ||
    path.match(/^\/category\/[^\/]+$/) ||
    path.match(/^\/search/) ||
    path.match(/^\/store\/list\/(category|topic)\/[^\/]+$/) ||
    path.match(/^\/experience\/[^\/]+$/) ||
    path.match(/^\/blog(\/.*)?$/) ||
    path.match(/^\/list-blog(\/.*)?$/) ||
    path.match(/^\/auth\/(signup|callback)$/) ||
    path.match(/^\/dashboard\/common(\/.*)?$/) ||
    path.match(/^\/dashboard\/admin(\/.*)?$/) ||
    path.match(/^\/dashboard\/farmer(\/.*)?$/);

  // A path is a 404 only if it doesn't match any valid static or dynamic route
  const is404Page = !validRoutes.includes(path) && !isDynamicRoute;

  // Hide header/footer for auth pages
  const isAuthPage = path.startsWith("/auth/");

  return (
    <MapViewProvider>
      <div className="app">
        <ScrollToTop />

        {!is404Page && !isAuthPage && (
          <>
            {/* 🌟 주소가 정확히 /global 메인일 때와 하위 상세페이지일 때를 명확히 분리하여 KoreaHeader를 강제로 깨웁니다 */}
            {path === "/global" ? (
              <KoreaHeader currentPath="/global" />
            ) : isGlobalFarmPage ? (
              <KoreaHeader />
            ) : isExplorePage ? (
              <ExploreHeader />
            ) : isMainBlogPage || isBlogPage ? (
              <BlogHeader />
            ) : isFarmPage ||
              isCategoryPage ||
              isListingPage ||
              isSearchPage ||
              isExperienceDetailPage ||
              isGlobalFarmPage ? (
              <ListHeader
                categoryStyle={isCategoryPage}
                searchStyle={isSearchPage}
                showMapToggle={!isSearchPage}
                hideMobileNav={isFarmPage || !!isExperienceDetailPage}
                globalStyle={isGlobalFarmPage}
              />
            ) : isProfilePage ? (
              <ProfileHeader />
            ) : (
              <Header />
            )}
          </>
        )}

        <main
          className={`main-content ${
            isSearchPage
              ? "search-list-main-content"
              : isFarmPage || isCategoryPage || isListingPage
                ? "list-main-content"
                : ""
          } ${is404Page ? "no-header-footer" : ""} ${isAuthPage ? "auth-main-content" : ""}`}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />

            <Route
              path="/farm/:farmId/:farmName"
              element={<FarmDetailPage />}
            />
            {/* <Route path="/farm/:farmId" element={<FarmDetailPage />} /> */}
            <Route path="/category/:categoryId" element={<FarmListPage />} />
            <Route path="/search" element={<SearchList />} />

            {/* FarmExplore */}
            <Route path="/stay" element={<FarmStayPage />} />
            <Route path="/experience" element={<FarmExperiencePage />} />
            <Route
              path="/experience/:experienceId"
              element={<ExperienceDetailPage />}
            />
            <Route path="/store" element={<FarmStorePage />} />
            <Route path="/store/list/:mode/:slug" element={<StoreListPage />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/list-blog" element={<WPPostsPage />} />
            <Route
              path="/blog/family-kids-friendly-christmas-tree-farms-ontario"
              element={<FamilyBlogPage />}
            />
            <Route
              path="/blog/best-christmas-markets-near-toronto"
              element={<ChristmasMarketsBlogPage />}
            />
            <Route
              path="/blog/best-christmas-markets-near-vancouver"
              element={<VancouverChristmasMarketsBlogPage />}
            />
            <Route
              path="/blog/best-lavender-farms-ontario"
              element={<LavenderFarmOntario />}
            />
            <Route
              path="/blog/blooming-adventures-countryside-charm"
              element={<BloomingAdventures />}
            />
            <Route
              path="/blog/the-best-farm-to-visit-april"
              element={<April />}
            />
            <Route
              path="/blog/celebrate-easter-2025-at-local-farms"
              element={<CelebrateEaster />}
            />
            <Route
              path="/blog/the-best-farm-to-visit-march"
              element={<March />}
            />
            <Route
              path="/blog/celebrate-maple-syrup-festival-in-ontario-2025"
              element={<MapleSyrup />}
            />
            <Route
              path="/blog/25-must-visit-maple-syrup-farms-near-toronto"
              element={<MapleSyrupFarm />}
            />
            <Route
              path="/blog/the-best-farm-to-visit-in-feb"
              element={<February />}
            />
            <Route
              path="/blog/4-ways-to-enjoy-evergreen-brick-works-this-week"
              element={<Evergreen />}
            />
            <Route
              path="/blog/4-must-visit-farms-near-toronto-before-christmas"
              element={<Christmas />}
            />
            <Route
              path="/blog/best-maple-syrup-farms-quebec"
              element={<MapleSyrupQC />}
            />
            <Route
              path="/blog/best-maple-syrup-farms-ontario"
              element={<MapleSyrupON />}
            />

            {/* 나중에 삭제 시작  */}
            <Route path="/global" element={<GlobalFarmPage />} />
            <Route
              path="/global/korea/yongggum-village"
              element={<YongggumVillage />}
            />
            <Route
              path="/global/korea/gapa-village"
              element={<GapaVillage />}
            />
            <Route
              path="/global/korea/onui-village"
              element={<OnuiVillage />}
            />
            {/* 나중에 삭제 끝  */}

            {/* Auth Routes */}
            <Route path="/auth/signup" element={<RoleSelectionPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />

            {/* Example Protected Routes - uncomment when pages are created */}
            <Route
              path="/dashboard/common/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/common/password-security"
              element={
                <ProtectedRoute>
                  <PasswordSecurityPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/common/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/common/notifications"
              element={
                <ProtectedRoute>
                  <NotificationPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard/common/bookmarks"
              element={
                <ProtectedRoute>
                  <BookmarksPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/common/favorites"
              element={
                <ProtectedRoute>
                  <FavoritesPage />
                </ProtectedRoute>
              }
            />

            {/* Admin Routes */}
            <Route
              path="/dashboard/admin/seo/farms"
              element={
                <ProtectedRoute>
                  <FarmSeoPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/admin/farm/listing"
              element={
                <ProtectedRoute>
                  <FarmListing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/admin/event/listing"
              element={
                <ProtectedRoute>
                  <EventListing />
                </ProtectedRoute>
              }
            />

            {/* <Route path="/bookmarks" element={<ProtectedRoute><BookmarksPage /></ProtectedRoute>} /> */}
            {/* <Route path="/favorites" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} /> */}

            {/* Catch-all route for 404 pages */}
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/auth/email-verified" element={<EmailVerified />} />
          </Routes>
        </main>

        {!is404Page && !isAuthPage && <Footer categoryStyle={isCategoryPage} />}
      </div>
    </MapViewProvider>
  );
}

export default App;
